import React from 'react';
import { Modal } from 'react-bootstrap';
import ResumePreview from '../ResumePreview';
import './styles.scss';

interface MyModalProps {
	showModal: boolean;
	handleClose: () => void;
}

const ResumePreviewModal: React.FC<MyModalProps> = ({ showModal, handleClose }) => {
	return (
		<Modal
			show={showModal}
			onHide={handleClose}
			aria-labelledby="contained-modal-title-vcenter"
			className="resume-preview-modal"
			centered
			fullscreen
		>
			<Modal.Header closeButton className="border-0 p-0 position-relative"></Modal.Header>
			<Modal.Body className="text-center p-0">
				<ResumePreview />
			</Modal.Body>
		</Modal>
	);
};

export default ResumePreviewModal;
